module.exports = __webpack_public_path__ + "static/img/coursera-c.e059e86f.svg";